export default __webpack_public_path__ + "static/media/campfire.27d272be.svg";